import { modalAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  // define the part you're going to style
  overlay: {
    bg: 'blackAlpha.700', //change the background
  },
  dialog: {
    borderRadius: 'md',
    bg: `white`,
    fontFamily: 'Inter, Roboto, sans-serif',
    color: 'blue.500',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    boxSizing: 'border-box',
  },
  closeButton: {
    borderRadius: 'full',
    color: 'gray.500',
  },
  header: {
    padding: '0 16px',
    // letterSpacing: '1px',
  },
  body: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
    fontSize: '18px',
    fontWeight: '700',
    color: 'blue.400',
  },
  footer: {
    display: 'flex',
    width: 'full',
    gap: '16px',
    padding: '20px 16px 16px',
  },
})

export const modalTheme = defineMultiStyleConfig({
  baseStyle,
})
